import styled from 'styled-components'
import { space, typography, SpaceProps, TypographyProps, alignSelf, AlignSelfProps } from 'styled-system'

export const BADGE_TYPES = {
  DEFAULT: undefined,
  ERROR: 'error',
  NEUTRAL: 'neutral',
  OUTLINED: 'outlined',
  SUCCESS: 'success',
  WARNING: 'warning',
  ALTERNATE: 'alternate'
}

const typeStyles = (props: any) => {
  switch (props.type) {
    case BADGE_TYPES.SUCCESS:
      return `
        color: light-dark(var(--brand-green-500), var(--brand-green-200));
        background-color: light-dark(var(--brand-green-100), var(--brand-green-500));
      `
    case BADGE_TYPES.ERROR:
      return `
      color: light-dark(var(--brand-red-500), var(--brand-red-200));
      background-color: light-dark(var(--brand-red-100), var(--brand-red-500));
      `
    case BADGE_TYPES.WARNING:
      return `
      color: light-dark(var(--brand-yellow-500), var(--brand-yellow-200));
      background-color: light-dark(var(--brand-yellow-200), var(--brand-yellow-500));
      `
    case BADGE_TYPES.NEUTRAL:
      return `
      color: light-dark(var(--brand-grey-500), var(--brand-grey-200));
      background-color: light-dark(var(--brand-grey-100), var(--brand-grey-500));
      `
    case BADGE_TYPES.ALTERNATE:
      return `
        color: light-dark(var(--brand-purple-500), var(--brand-purple-200));
        background-color: light-dark(var(--brand-purple-100), var(--brand-purple-500));
        `
    case BADGE_TYPES.OUTLINED:
      return `
          color: light-dark(var(--brand-grey-500), var(--brand-grey-200));
          background-color: 'transparent';
          border: 1px solid light-dark(var(--brand-grey-200), var(--brand-grey-400));
        `

    case BADGE_TYPES.DEFAULT:
    default:
      return `
      color: light-dark(var(--brand-grey-500), var(--brand-grey-200));
      background-color: light-dark(var(--brand-grey-100), var(--brand-grey-500));
      `
  }
}

export interface BadgeProps extends SpaceProps, TypographyProps, AlignSelfProps {
  type?: (typeof BADGE_TYPES)[keyof typeof BADGE_TYPES]
}

const Badge = styled.span.attrs(props => ({
  py: '4px',
  px: '10px',
  fontWeight: 'semibold',
  fontSize: 1,
  ...props
}))<BadgeProps>`
  width: max-content;
  border-radius: 16px;
  display: inline-block;
  text-transform: uppercase;
  line-height: 14px;
  text-align: center;
  vertical-align: middle;
  letter-spacing: 0.03em;
  white-space: nowrap;

  ${props => typeStyles(props)}
  ${space}
  ${typography}
  ${alignSelf}
`

export default Badge
